import styled from 'styled-components';

import search from 'assets/png/search.png';

export const Search = styled.img.attrs({ alt: 'search', src: search })`
  height: 20px;
  width: 20px;
  margin-left: 15px;
`;
